import { render, staticRenderFns } from "./InformacionGeneralModal.vue?vue&type=template&id=19f1c6b0"
import script from "./InformacionGeneralModal.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralModal.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralModal.vue?vue&type=style&index=0&id=19f1c6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports